// react
import React from 'react';

// third-party
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

// application
import NavPanel from './NavPanel';
import Search from './Search';
import Topbar from './Topbar';


function Header(props) {
    const { layout } = props;
    let bannerSection;

    if (layout === 'default') {
        bannerSection = (
            <div className="site-header__middle container">
                <div className="site-header__logo">
                    <Link to="/"> <img height="60" src="images/logos/tsttools-logo.png" alt="TSTTOOLS Logo" /></Link>
                </div>
                <div className="site-header__search">
                    <Search />
                </div>
                <div className='site-header-messagers'>
                    <div className='messagers-item'>
                        <Link to={{pathname: "https://t.me/BiruykovaValentina"}} target="_blank"> <img height="40" src="images/ico/telegram.png" alt="telegram" /></Link>
                    </div>
                    <div className='messagers-item'>
                        <Link to={{pathname:"https://wa.me/79139473115" }} target="_blank">  <img height="40" src="images/ico/whatsapp.png" alt="whatsapp" /></Link>
                    </div>
                </div>
                <div className="site-header__phone">
                    <div className="site-header__phone-title">
                        <FormattedMessage id="header.phoneLabel" defaultMessage="Customer Service" />
                    </div>
                    <div className="site-header__phone-number">
                        <FormattedMessage id="header.phone" defaultMessage="+7 (499) 322-22-56" />
                    </div>
                    
                    <div className="site-header__phone-number">
                        <FormattedMessage id="header.email" defaultMessage="info@tsttools.ru" />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="site-header">
            <Topbar />
            {bannerSection}
            <div className="site-header__nav-panel">
                <NavPanel layout={layout} />
            </div>
        </div>
    );
}

Header.propTypes = {
    /** one of ['default', 'compact'] (default: 'default') */
    layout: PropTypes.oneOf(['default', 'compact']),
};

Header.defaultProps = {
    layout: 'default',
};

export default Header;
